module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.formatData) ? _c('div', {
    staticClass: "client-item-box",
    attrs: {
      "id": 'nofixNav' + _vm.data.nofixNavId + '-' + _vm.data.nofixNavIndex,
      "data-trackdata": _vm.tData
    },
    on: {
      "click": _vm.videoAction
    }
  }, [_c('div', {
    class: _vm.videowrap,
    style: ({
      height: ((_vm.formatData.height) + "px"),
      overflow: 'hidden'
    })
  }, [_c('beast-video', {
    attrs: {
      "wrap": _vm.videowrap,
      "height": _vm.formatData.videoHeight,
      "poster": _vm.formatData.poster,
      "autoplay": _vm.formatData.autoplay,
      "source": _vm.formatData.source,
      "controls": _vm.formatData.controls,
      "videoFormat": _vm.formatData.videoFormat,
      "muted": _vm.formatData.muted,
      "videoPopData": _vm.formatData.videoPopData,
      "multiVideo": _vm.multiVideo
    },
    on: {
      "video-pop": _vm.videoPopAction
    }
  })], 1), _vm._v(" "), (_vm.videoPopFlag) ? _c('video-pop', {
    attrs: {
      "data": _vm.videoPopData
    },
    on: {
      "close": _vm.closeAction
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-038c28bc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/renderer-config/components/video.vue
// module id = 545
// module chunks = 1 5 14